import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface Props {
  label: string;
  children: React.ReactNode;
}

/** Accessible help tooltip; keyboard focusable. */
const HelpTip: React.FC<Props> = ({ label, children }) => (
  <Tooltip title={children} describeChild enterTouchDelay={0}>
    <IconButton
      size="small"
      aria-label={label}
      sx={{ ml: 0.25, p: 0.25, color: 'text.secondary' }}
    >
      <HelpOutlineIcon fontSize="inherit" sx={{ fontSize: 16 }} />
    </IconButton>
  </Tooltip>
);

export default HelpTip;
